// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__1vKKC","content":"styles_content__2D0La","checkbox":"styles_checkbox__1MjKu","checkboxLabel":"styles_checkboxLabel__1-7rA"};